<div class="dialog-container">
  <div class="page">
    <div class="page-title-line">
      <span class="page-title">Subscription Assignment Manager</span>
      <span *ngIf="!isLoading()" class="assignment-count">{{assignedCount + '/' + data.subscription.quantity}}</span>
      <mat-select class="standalone-select" placeholder="None" [(ngModel)]="version" [disabled]="editing">
        <mat-option *ngFor="let compass of data.compasses" [value]="compass.id">
          {{compass.name}}
        </mat-option>
      </mat-select>
    </div>
    <div class="page-body">
      <div class="page-body-sidebar standard-listing" *ngVar="getRelevantAssignments() as assignments">
        <input #filter class="header" type="text" placeholder="Filter assignments..." [disabled]="editing" [(ngModel)]="filterText" />
        <div *ngIf="isLoading()" class="listings">
          <listing-component *ngFor="let listing of [1,2,3,4,5,6,7,8,9]" [skeleton]="true" [hasAvatar]="false"
            [hasDesc]="true" [longTitleSkeleton]="true"></listing-component>
        </div>
        <div *ngIf="!isLoading() && assignments.length == 0" class="empty-state">
          Nothing to show
        </div>
        <div *ngIf="!isLoading() && assignments.length > 0" class="listings">
          <listing-component *ngFor="let listing of assignments" [title]="listing.getListingName()" [scoredAssignment]="listing" [smallSpacing]="true" [hasAvatar]="false"
            [disabled]="editing" [selected]="isSelected(listing)" (click)="select(listing)"></listing-component>
        </div>
        <button mat-icon-button *ngIf="!isLoading()" class="circle-button" title="Add a new assignment" [disabled]="editing || !canAssign()" (click)="add()">
          <img src="assets/content-icon/ic-04.svg" />
        </button>
      </div>
      <div *ngIf="isLoading()" class="page-body-content">
        <div class="fields skeleton">
          <div class="input-area">
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button mat-button class="text-button" disabled>Edit</button>
        </div>
      </div>
      <div *ngIf="!isLoading() && !selected" class="page-body-content center">
        <div class="empty-title">{{getEmptyStateTitle()}}</div>
        <div class="empty-desc">{{getEmptyStateDesc()}}</div>
      </div>
      <div *ngIf="!isLoading() && selected" class="page-body-content">
        <div class="fields">
          <div class="input-area">
            <!-- Relationship type -->
            <div class="input-container" *ngVar="selected.subjectType as field"
              [title]="(!editing || !field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Subject Type</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The type of user to make this assignment to.  A journaled-for user is fully managed by the users that journal for them, and every other user is a normal user.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="Subject Type" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value" [disabled]="!editing || !field.isEditable()">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Subject -->
            <div class="input-container" *ngVar="selected.subject as field"
              [title]="(!editing || !field.isEditable()) ? '' : field.value"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Subject {{selected.getSubjectTypeText()}}</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The ' + selected.getSubjectTypeText().toLocaleLowerCase() + ' of the subject.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="128" [placeholder]="'Subject ' + selected.getSubjectTypeText().toLocaleLowerCase()" (blur)="field.touch()" [(ngModel)]="field.value"
                [disabled]="!editing || !field.isEditable()" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Takes Own Assessment -->
            <div class="input-container" *ngVar="selected.takesOwnAssessment as field"
              [title]="(!editing || !field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty(), hidden: selected.isLogFor()}">
              <div class="label-line">
                <span class="label">Subject Takes Assessment</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'Whether or not the subject should take the assessment themselves, in addition to any specified assessment takers.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="Subject Takes Assessment" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value" [disabled]="!editing || !field.isEditable()">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Score Level -->
            <div class="input-container" *ngVar="selected.subjectScoreLevel as field"
              [title]="(!editing || !field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty(), double: selected.isNew() && selected.isLogFor()}">
              <div class="label-line">
                <span class="label">Score Level</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The way the score will be displayed for the user in the Huddy app. \'Summary\' scores show up in the home page carousel as a single score, \'Component\' scores show up huddy score cards for each of their components, and \'Detailed\' scores show breakdowns in the clinician report and the summary score in the home page carousel.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="Score Level" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value" [disabled]="!editing || !field.isEditable()">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Status -->
            <div *ngIf="!selected.isNew()" class="input-container" [ngClass]="{double: !selected.isLogFor()}" [title]="selected.getStatusText()">
              <div class="label-line">
                <span class="label">Status</span>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The current status of the assignment.  Can be Confirmed, Pending, or Unassigned.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" [ngModel]="selected.getStatusText()" disabled />
            </div>
            <!-- Assessment Takers -->
            <div *ngIf="editing || selected.assessmentTakers?.length > 0" class="double">
              <div class="subheader-line" *ngVar="selected.assessmentTakersGroup as group"
                [ngClass]="{dirty: !selected.isNew() && group.isDirty(), error: group.hasVisibleIssue()}">
                <div class="subheader-text">
                  <span class="subheader">Assessment Takers</span>
                  <div class="dot"></div>
                  <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                    (click)="showFieldInfo($event, 'The set of users that will take assessments for the subject of the assignemt.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <button mat-button *ngIf="editing" class="text-button subheader-button custom-size custom-color" (click)="selected.addAssessmentTaker(); setShouldScrollToNew()">
                  Add assessment taker
                </button>
              </div>
              <div *ngIf="selected.assessmentTakers.length == 0" class="empty-state"
                [ngClass]="{error: selected.statusField.getDisplayedIssue()}">
                {{selected.statusField.getDisplayedIssue() || 'Nothing to show'}}
              </div>
              <div (ngInit)="scrollToNew($event)" class="card input-area" *ngFor="let assessmentTaker of selected.assessmentTakers; index as i"
                [ngClass]="{dirty: assessmentTaker.isDirty() || (selected.isDirty() && assessmentTaker.isNew), invalid: assessmentTaker.hasVisibleIssue()}">
                <button mat-button *ngIf="editing" class="text-button corner-button" title="Remove assessment taker"
                  (click)="selected.removeAssessmentTaker(i); selected.statusField.touch();">
                  <img src="assets/content-icon/ic-05.svg" class="icon" />
                </button>
                <!-- Email -->
                <div class="input-container" *ngVar="assessmentTaker.email as field"
                  [title]="(!editing || !field.isEditable()) ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !assessmentTaker.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Email</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The email of the assessment taker.')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input type="text" class="input" maxlength="128" placeholder="Email" (blur)="field.touch()"
                    [(ngModel)]="field.value" [disabled]="!editing || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <!-- Score Level -->
                <div class="input-container" *ngVar="assessmentTaker.scoreLevel as field"
                  [title]="(!editing || !field.isEditable()) ? '' : field.getDisplayValue()"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !assessmentTaker.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Score Level</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The way the score will be displayed for the user in the Huddy app. \'Summary\' scores show up in the home page carousel as a single score, \'Component\' scores show up huddy score cards for each of their components, and \'Detailed\' scores show breakdowns in the clinician report and the summary score in the home page carousel.')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <mat-select class="input select" placeholder="Score Level" (openedChange)="field.openedChange($event)"
                    (blur)="field.handleBlur($event)" [(ngModel)]="field.value" [disabled]="!editing || !field.isEditable()">
                    <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                      {{option.displayValue}}
                    </mat-option>
                  </mat-select>
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <mat-progress-spinner *ngIf="selected.isSaving()" class="spinner" color="primary" mode="indeterminate" diameter="21">
          </mat-progress-spinner>
          <div *ngIf="editing">
            <button mat-button class="text-button secondary" [disabled]="selected.isSaving()" (click)="edit(false)">Cancel</button>
            <button mat-button *ngIf="selected.isUnassigned()" class="text-button secondary" [disabled]="selected.isDirty() || !canAssign()" (click)="assign(true)">Assign</button>
            <button mat-button *ngIf="selected.isPending()" class="text-button secondary" [disabled]="selected.isDirty()" (click)="assign(false)">Unassign</button>
            <button mat-button class="text-button" [disabled]="!selected.saveEnabled()" (click)="save(selected)">{{selected.id == null ? 'Create' : 'Save'}}</button>
          </div>
          <div *ngIf="!editing">
            <button mat-button *ngIf="canViewResults(selected)" class="text-button secondary" (click)="viewResults(selected)">View user</button>
            <button mat-button class="text-button" (click)="edit()">Edit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="backdrop" [ngClass]="{showing: fieldInfoShowing}" (click)="hideFieldInfo()">
  <div #fieldInfo class="popover" [ngClass]="{showing: fieldInfoShowing}" [style]="fieldInfoPosition"
    (click)="$event.stopPropagation()">
    <div class="popover-content">
      <div class="text"></div>
    </div>
  </div>
  <div class="popover-arrow" [ngClass]="{showing: fieldInfoShowing}" [style]="fieldInfoArrowPosition"></div>
</div>